<h2>Trivia Race Game!</h2>
<p>Ever want to test your trivia knowledge against your friends? Well then this is the game for you!</p>
<p>This is a simple game of wit and speed, you will be presented with a series of multiple choice questions, you will get credit for getting the correct answer.</p>
<p>The faster you answer, the more points you will receive.</p>
<h3>First to 100 points wins!</h3>
<p>Earn up to 20 points per correct answer.</p>
